
import React from 'react';
import range from 'lodash/range';
import './index.scss';

const LevelDots = (props) => {
  const { level, trail } = props;
  if (trail && level) {
    return (range(level)).map(level => (
      <span key={level} className={`badgeDot level-${level + 1}`} />
    ));
  }
  if (!trail && level) {
    return <span className={`badgeDot level-${level}`} />;
  }
  return '';
};

export default LevelDots;



// WEBPACK FOOTER //
// ./src/components/levelDots/index.js